import React from "react";
export const SonosCheckout = (props) => {
  return (
    <div className="page sonos">
    </div>
  );
};

export default SonosCheckout;
